module.exports = __webpack_public_path__ + "img/nav-vehicle-models-cjdr.d1b84f2c.png";